import { createSelector } from 'redux-starter-kit';

const caseSelector = (state: any) => state.case;

export const customersSelectors = {
  customers: createSelector(caseSelector, subState => subState.customers)
};
